import { locale, tn } from "./i18n";

// Someone's local time, and how far it is from one's own.

// offsetMinutes is a time zone's offset from UTC at a moment, in minutes.
function offsetMinutes(zone: string, at: Date): number {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: zone, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).formatToParts(at);
  const n = (t: string) => Number(parts.find((p) => p.type === t)?.value);
  const local = Date.UTC(n("year"), n("month") - 1, n("day"), n("hour") % 24, n("minute"));
  return Math.round((local - Math.floor(at.getTime() / 60_000) * 60_000) / 60_000);
}

// localTime says what time it is in a zone ("3:40 PM"), and how it stands
// to another zone: "7 hours ahead", "2½ hours behind", or "" if the same.
export function localTime(zone: string, mine: string, at = new Date()): { time: string; diff: string } | null {
  try {
    const time = at.toLocaleTimeString(locale, { timeZone: zone, hour: "numeric", minute: "2-digit" });
    const d = offsetMinutes(zone, at) - offsetMinutes(mine, at);
    if (d === 0) return { time, diff: "" };
    const h = Math.abs(d) / 60;
    const hours = Number.isInteger(h) ? String(h) : Number.isInteger(h * 2) ? `${Math.floor(h)}½` : h.toFixed(2);
    return { time, diff: d > 0 ? tn(h, "{hours} hour ahead", "{hours} hours ahead", { hours }) : tn(h, "{hours} hour behind", "{hours} hours behind", { hours }) };
  } catch {
    return null;
  }
}

// browserZone is the time zone this browser runs in.
export const browserZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

// timeZones is every time zone this browser knows, with the one chosen
// among them.
export function timeZones(chosen: string): string[] {
  let all: string[] = [];
  try {
    all = Intl.supportedValuesOf("timeZone");
  } catch {
    // An older browser lists only the chosen one.
  }
  return all.includes(chosen) ? all : [chosen, ...all];
}
